import { deleteElement, fetchElements, saveElements, updateElement } from "@/lib/utils";
import { removeFiles, uploadFile } from "@/lib/file";
import { directus } from "@/lib/directus";
import { updateFile } from "@directus/sdk";
import type { Folders, FileItem } from "@/types/types";
import type { FoldersRepository } from "@/lib/repositories/interfaces/folders-repository.interface";

export const FOLDERS_FIELDS = [
  "*", 
  "files.*",
  "proyecto_au.*", 
  "proyecto_au.translations.*",
  "feder_operacion.*", 
  "feder_operacion.translations.*",
  "feder_contrato.*", 
  "feder_contrato.translations.*",
  "proyecto_propio.*", 
  "proyecto_propio.translations.*",
  "otro_proyecto.*", 
  "otro_proyecto.translations.*",
  "otra_actuacion.*", 
  "otra_actuacion.translations.*",
  "otra_transaccion.*",
  "actuacion_propia.*", 
  "actuacion_propia.translations.*",
  "transaccion_propia.*",
  "actuacion_au.*", 
  "actuacion_au.translations.*",
  "indicador_au.*", 
  "indicador_au.translations.*",
  "feder_proyecto.*", 
  "feder_proyecto.translations.*",
  "feder_actuacion.*", 
  "feder_actuacion.translations.*",
  "feder_indicador.*",
];

export const foldersRepository: FoldersRepository = {
  fetchByTenant: (tenantId: number): Promise<Folders[]> =>
    fetchElements<Folders>("folders", FOLDERS_FIELDS, undefined, { tenant: { _eq: tenantId } }),

  create: (payload: Partial<Folders>) =>
    saveElements("folders", [payload as any]) as Promise<Folders[]>,

  update: (id: number, changes: Partial<Folders>) => updateElement("folders", id, changes as any),

  delete: (id: number): Promise<void> => deleteElement("folders", id),

  createFiles: (payloads: Partial<FileItem>[]) =>
    saveElements("file", payloads as any) as Promise<FileItem[]>,

  updateFileItem: (id: number, changes: Partial<FileItem>) => updateElement("file", id, changes as any),

  deleteFileItem: (id: number): Promise<void> => deleteElement("file", id),

  uploadDirectusFile: async (file: File): Promise<string> => {
    const first = (await uploadFile(file))?.[0];
    const id = ((first as any)?.id ?? (first as any)?.data?.id) as string | undefined;
    if (!id) throw new Error("Directus upload did not return an id");
    return id;
  },

  removeDirectusFiles: (ids: string[]) => removeFiles(ids),

  updateDirectusFilename: (id: string, filename_download: string) =>
    directus.request(updateFile(id, { filename_download })),
};
